import React from 'react';
import { Column } from '../components/shared/Column';
import { Grid } from '../components/shared/Grid';
import { Stepper, StepperStep } from '../components/shared/Stepper';

import { BaseLayout } from '../components/template/BaseLayout';

import { Text } from '../components/shared/Text';

export const ThankYou = () => {
    return (
        <BaseLayout>
            <Grid>
                <Column cols={[12, null, null, 7]}>
                    <Stepper
                        defaultUrl="/afspraak"
                        defaultPreviousText="Terug"
                        previousButtonTexts={[]}>
                        <StepperStep id={0}>
                            <div className="u-padding-top--md u-padding-bottom--sm">
                                <Text as="h3">Bedankt voor het maken van een afspraak</Text>
                                <p>
                                    De adviseur van De Hypotheker neemt zo spoedig mogelijk contact
                                    op om de afspraak in te plannen.
                                </p>
                            </div>
                        </StepperStep>
                    </Stepper>
                </Column>
            </Grid>
        </BaseLayout>
    );
};
